import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 20px;
        height: 65px;
        box-shadow: 0px 2px 2px 0px lightgray;
        gap: 25px;
    `,
    User: styled("div")`
        display: flex;
        align-items: center;
    `,
};
